import React, { useState } from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import { ArrowLeft, Calendar, Clock, Building2, MapPin, DollarSign, Users, TrendingUp, FileText, Briefcase, Target, MessageSquare, Brain, CheckCircle, AlertCircle, ExternalLink, Plus, X, Loader } from 'lucide-react';

const InterviewPreparationReport = ({ 
interview
 }) => {


return (
<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
<h2 className="text-xl font-bold text-gray-900 mb-4">Interview Preparation Report</h2>

<div className="mb-6">
<h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
<Briefcase className="w-5 h-5 text-blue-600" />
Role Analysis
</h3>

<div className="space-y-4">
<div>
<h4 className="font-medium text-gray-900 mb-2">Key Responsibilities</h4>
<ul className="space-y-2">
{interview.preparationReport.roleAnalysis.keyResponsibilities.map((resp, index) => (
<li key={index} className="flex items-start gap-2">
<CheckCircle className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" />
<span className="text-gray-700">{resp}</span>
</li>
))}
</ul>
</div>

<div>
<h4 className="font-medium text-gray-900 mb-2">Required Skills</h4>
<div className="flex flex-wrap gap-2">
{interview.preparationReport.roleAnalysis.requiredSkills.map((skill, index) => (
<span key={index} className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">
{skill}
</span>
))}
</div>
</div>

<div>
<h4 className="font-medium text-gray-900 mb-2">Nice to Have</h4>
<div className="flex flex-wrap gap-2">
{interview.preparationReport.roleAnalysis.niceToHave.map((skill, index) => (
<span key={index} className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full text-sm">
{skill}
</span>
))}
</div>
</div>
</div>
</div>

<div className="mb-6">
<h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
<MessageSquare className="w-5 h-5 text-purple-600" />
Potential Interview Questions
</h3>

<div className="space-y-4">
{interview.preparationReport.potentialQuestions.map((category, catIndex) => (
<div key={catIndex} className="border border-gray-200 rounded-lg p-4">
<h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
<Target className="w-4 h-4" />
{category.category}
</h4>
<ul className="space-y-2">
{category.questions.map((question, qIndex) => (
<li key={qIndex} className="flex items-start gap-2">
<span className="text-blue-600 font-medium flex-shrink-0">{qIndex + 1}.</span>
<span className="text-gray-700">{question}</span>
</li>
))}
</ul>
</div>
))}
</div>
</div>

<div>
<h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
<FileText className="w-5 h-5 text-orange-600" />
Preparation Tips
</h3>
<div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
<ul className="space-y-2">
{interview.preparationReport.preparationTips.map((tip, index) => (
<li key={index} className="flex items-start gap-2">
<AlertCircle className="w-4 h-4 text-orange-600 mt-0.5 flex-shrink-0" />
<span className="text-gray-700">{tip}</span>
</li>
))}
</ul>
</div>
</div>
</div>
);
};

export default InterviewPreparationReport;